import { AlertTriangle } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

interface ScheduledArchivationAlertProps {
  message: string;
  className?: string;
}

/**
 * Alert banner displayed when an entity is scheduled for future archivation or unarchivation.
 * Shows a warning with the scheduled date.
 *
 * @example
 * // For scheduled archivation
 * <ScheduledArchivationAlert
 *   message={t('authenticated.projects:scheduledArchive.willBeArchivedOn', { date: '...' })}
 * />
 *
 * // For scheduled unarchivation
 * <ScheduledArchivationAlert
 *   message={t('authenticated.projects:scheduledArchive.willBeUnarchivedOn', { date: '...' })}
 * />
 */
export function ScheduledArchivationAlert({ message, className }: ScheduledArchivationAlertProps) {
  return (
    <Alert variant="warning" className={className}>
      <AlertTriangle className="h-5 w-5" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
